import classNames from 'classnames'
import styles from './SplitSection.module.scss'
import { SplitSectionProps } from './types'
import { PropsWithChildren } from 'react'

const SplitSection = ({ className, children, color, id }: PropsWithChildren<SplitSectionProps>) => {
  return (
    <section id={id} className={classNames('section', styles.section, className)} data-color={color}>
      {children}
    </section>
  )
}

const Left = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className="container">
      <div className={classNames(styles['left-content'], className)}>{children}</div>
    </div>
  )
}

const Right = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return <div className={classNames(styles['right-content'], className)}>{children}</div>
}

SplitSection.Left = Left
SplitSection.Right = Right

export default SplitSection
